import VisaIcon from '../assets/icons/Visa.svg';
import MasterCardIcon from '../assets/icons/Mastercard.svg';
import AmexIcon from '../assets/icons/AmexNew.svg';
import DiscoverIcon from '../assets/icons/DiscoverNew.svg';
import Dinersclub from '../assets/icons/Dinersclub.svg';
import CartebancaireIcon from "../assets/icons/cartebancaire.svg"

export enum PAYMENT_METHODS {
    BRAINTREE_PAYPAL_PAYLATER = 'Braintree_PaypalPayLater',
    BRAINTREE_PAYPAL = 'Braintree_Paypal',
    BRAINTREE_CREDITCARD = 'Braintree_CreditCard',
    ADYEN_CREDITCARD = 'Adyen_CreditCard',
    ADYEN_GOOGLEPAY = 'Adyen_GooglePay',
    INTERNAL_ONACCOUNT = 'Internal_OnAccount',
    ON_ACCOUNT = 'ON_ACCOUNT',
    BRAINTREE_APPLE_PAY = 'Braintree_ApplePay',
    ADYEN_KLARNA_PAY_NOW = 'Adyen_KlarnaPayNow',
    ADYEN_IDEAL = 'Adyen_Ideal'
}

export enum PAYMENT_INTERFACE {
    INTERNAL = 'INTERNAL'
}

export enum TYPE {
    SCHEME = 'scheme',
    GOOGLEPAY = 'googlepay',
    IDEAL = 'ideal'
}

export enum I_TYPE {
    AC = 'AC',
    AD = 'AD'
}

export const creditCardBrandsCardLogosMap = new Map([
    ['mc', MasterCardIcon],
    ['visa', VisaIcon],
    ['amex', AmexIcon],
    ['diners', Dinersclub],
    ['discover', DiscoverIcon],
    ['cartebancaire',CartebancaireIcon]
]);


export enum PAYMENT_METHOD_CAMEL_CASE {
    PAYPAL = 'paypal',
    CREDIT_CARD = 'creditCard',
    IDEAL = 'ideal'
}

export enum PAYMENT_METHOD_UPPER_CAMEL_CASE {
    IDEAL = 'Ideal'
}

export enum ADYEN_COMPONENTS {
    CARD = 'card',
    GOOGLE_PAY = 'googlepay',
    KLARNA_PAY = 'klarna_paynow'
}

export enum ID_TYPE {
    CART_ID = 'cartId',
}

export enum CHANNEL {
    ABC = 'ABC',
}

export function isApplePaySupported() {
    return ((window as any).ApplePaySession && (window as any).ApplePaySession.canMakePayments);
}

export enum EXPRESS_CHECKOUT_COOKIE_NAMES {
    EXPRESS_CHECKOUT = 'expressCheckout',
    APPLE_PAY_EXPRESS_CHECKOUT = 'applePayExpressCheckout'
}

export enum CHANNEL_TYPE {
    PAYPAL_EXPRESS = 'paypalExpress',
    APPLE_PAY_EXPRESS = 'applePayExpress'
}